import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  ButtonModule,
  ChipsModule,
  DropdownModule,
  SvgIconModule,
  TableModule,
  TextFieldModule,
  UtilsModule
} from '@mtgame/ui';
import { HandballGameStatisticComponent } from './handball-game-statistic/handball-game-statistic.component';
import { HandballGameMvpUsersComponent } from './handball-game-mvp-users/handball-game-mvp-users.component';
import { HandballGameProtocolComponent } from './handball-game-protocol/handball-game-protocol.component';
import { HandballGameTimelineComponent } from './handball-game-timeline/handball-game-timeline.component';
import { HandballGameTimelineItemComponent } from './handball-game-timeline/handball-game-timeline-item.component';
import { HandballGameDocumentsComponent } from './handball-game-documents/handball-game-documents.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    UtilsModule,
    DropdownModule,
    TextFieldModule,
    TableModule,
    SvgIconModule,
    ChipsModule,
    ButtonModule,
  ],
  declarations: [
    HandballGameStatisticComponent,
    HandballGameMvpUsersComponent,
    HandballGameProtocolComponent,
    HandballGameTimelineComponent,
    HandballGameTimelineItemComponent,
    HandballGameDocumentsComponent,
  ],
  exports: [
    HandballGameStatisticComponent,
    HandballGameMvpUsersComponent,
    HandballGameProtocolComponent,
    HandballGameTimelineComponent,
    HandballGameDocumentsComponent,
  ],
})
export class HandballGameModule {}
